import _ from 'lodash'

export function boundingBoxToCoords(boundingBox) {
  // boundingBox: {
  //   topLeft: [162.91, -17.42],
  //   bottomRight: [548.56, 368.23],
  // }
  const { topLeft, bottomRight } = boundingBox
  const minX = topLeft[1]
  const maxX = bottomRight[1]
  const maxY = topLeft[0]
  const minY = bottomRight[0]
  return [minX, minY, maxX, maxY]
}

export function getBoundingBoxCoords(landmarks) {
  // landmarks: [ // The 3D coordinates of each hand landmark.
  //   [472.52, 298.59, 0.00],
  //   [412.80, 315.64, -6.18],
  //   ...
  // ]
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity
  landmarks.forEach((landmark) => {
    minX = Math.min(minX, landmark[0])
    maxX = Math.max(maxX, landmark[0])
    minY = Math.min(minY, landmark[1])
    maxY = Math.max(maxY, landmark[1])
  })
  return [minX, minY, maxX, maxY]
}

export function computeIou(boundingCoords, targetCoords) {
  // coords system: [minX, minY, maxX, maxY]
  const minIntersectX = _.max([boundingCoords[0], targetCoords[0]])
  const minIntersectY = _.max([boundingCoords[1], targetCoords[1]])
  const maxIntersectX = _.min([boundingCoords[2], targetCoords[2]])
  const maxIntersectY = _.min([boundingCoords[3], targetCoords[3]])
  const intersectArea =
    _.max([0, maxIntersectX - minIntersectX]) *
    _.max([0, maxIntersectY - minIntersectY])
  const boundingArea = computeArea(boundingCoords)
  const targetArea = computeArea(targetCoords)
  const iou = intersectArea / (targetArea + boundingArea - intersectArea)
  return iou
}

export function generateBoxCoords(
  widthMinMax,
  heightMinMax,
  screenXMinMax,
  screenYMinMax
) {
  // fix this logic, should be absolute
  const width = _.random(widthMinMax[0], widthMinMax[1])
  const height = _.random(heightMinMax[0], heightMinMax[1])
  const minX = _.random(screenXMinMax[0], screenXMinMax[1] - width)
  const minY = _.random(screenYMinMax[0], screenYMinMax[1] - height)
  return [minX, minY, minX + width, minY + height]
}

export function computeArea(boxCoords) {
  const width = boxCoords[2] - boxCoords[0]
  const height = boxCoords[3] - boxCoords[1]
  return width * height
}

export function flipResults(reversedResults, dimensions) {
  return reversedResults.map((result) => {
    const processedLandmarks = result.landmarks.map((landmark) => {
      return [landmark[0] + dimensions.width, landmark[1], landmark[2]]
    })
    const { topLeft, bottomRight } = result.boundingBox
    const processedBoundingBox = {
      topLeft: [topLeft[0] + dimensions.width, topLeft[1]],
      bottomRight: [bottomRight[0] + dimensions.width, bottomRight[1]],
    }
    return {
      ...result,
      landmarks: processedLandmarks,
      boundingBox: processedBoundingBox,
    }
  })
}
